// extracted by mini-css-extract-plugin
export var container = "_d9-0";
export var infoIcon = "_d9-2";
export var internalLabel = "_d9-3";
export var titleRowCol = "_d9-1";